import { Message } from '@/models/message.model';
import { PersistentStore } from './main';
import messageRepository from '@/api/messageRepository';

interface MessageStoreModel extends Object {
  message: Message | null;
  loading: boolean;
}

class MessageStore extends PersistentStore<MessageStoreModel> {
  protected data(): MessageStoreModel {
    return {
      message: null,
      loading: false,
    };
  }
  getMessageByMessageId(messageid: number, params: Record<string, string>) {
    this.state.loading = true;
    return new Promise((resolve, reject) => {
      messageRepository
        .getMessageByMessageId(messageid, params)
        .then((response: Message) => {
          this.setMessage(response);
          resolve(response);
        })
        .catch(error => reject(error))
        .finally(() => {
          this.state.loading = false;
        });
    });
  }
  setMessage(message: Message | null) {
    this.state.message = message;
  }
}
export const messageStore = new MessageStore('MESSAGE_STORE');
